import angular from 'angular';
import 'angular-cache';

import {
    BuyStylesPopoverComponentOptions,
    populateBuyStylesTemplateCache,
} from './buy-styles.view/buy-styles-popover';
import { FontCssService } from './font-css.service/font-css.service';

import { FontPaginationService } from './font-pagination.service/font.pagination.service';

import { SeriesRepository, SeriesService } from './SeriesService';
import { FontLoader } from './fontloader.service/fontloader.service';
import { LocalPackages } from './local-packages.service/localPackages';
import { otFeatureDescription } from './ot-feature-description.filter/ot-feature-description';
import { PackageRepository } from './package-repository.service/package-repository';
import { pangramService } from './pangram.service/pangram';

import { FilterService2, FilterServicePersisted } from '../tn.common';
import { BuySearchButtonComponent } from './buy-styles.view/buy-search-button';
import { BuyStylesButtonComponentOptions } from './buy-styles.view/buy-styles-button';
import { TnGlyphCaseTreeComponentOptions } from './tn-glyphs.directive/tn-glyph-case-tree.directive/tn-glyph-case-tree';
import { TnGlyphsComponentOptions } from './tn-glyphs.directive/tn-glyphs';
import { tnFontsCacheFactory } from './tn.fonts.service/ds-cache-factory';
import { PeopleService } from './tn.fonts.service/people';

export default angular
    .module('tn.fonts', [
        'angular-cache',
        'tn.django',
        'tn.favorites',
        'tn.utils',
        'ngTouch',
        'tn.ui',
    ])
    .component('tnGlyphs', TnGlyphsComponentOptions)
    .component('tnGlyphCaseTree', TnGlyphCaseTreeComponentOptions)
    .component('buyStylesPopover', BuyStylesPopoverComponentOptions)
    .component('buyStylesButton', BuyStylesButtonComponentOptions)
    .component('buySearchButton', BuySearchButtonComponent)
    // providers
    .constant('fontServerAddress', 'TN_FONT_SERVER_ADDRESS')
    .filter('otFeatureDescription', otFeatureDescription)
    .service('localPackages', LocalPackages)
    .service('seriesService', SeriesService)
    .service('packageRepository', PackageRepository)
    .service('pangramService', pangramService)
    .service('seriesRepository', SeriesRepository)
    .service('tn.fonts.service.pagination', FontPaginationService)
    .service('tn.fontCssService', FontCssService)
    .service('tn.fontloader.service', FontLoader)
    .service('tn.people.service', PeopleService)
    .service('tnFontFilterService', FilterServicePersisted)
    .service('tnFontFilterServiceAccountLicenses', FilterService2)
    .service('tnFontFilterServiceAccountOrders', FilterService2)
    .service('tnFontFilterServiceAccountYourFonts', FilterService2)
    .service('tnFontFilterServiceFamilyDetail', FilterServicePersisted)
    .service('tnFontFilterServiceFavorites', FilterService2)
    .service('tnFontFilterServiceProjects', FilterService2)
    .service('tnFontFilterServiceSeriesDetail', FilterServicePersisted)
    .service('tnFontFilterServiceStyleDetail', FilterService2)
    // bootstrap
    .run(tnFontsCacheFactory)
    .run(populateBuyStylesTemplateCache).name;
